import { initContract } from '@ts-rest/core';
import { apiErrorSchema, authHeaders } from './schemas/common.js';
import { activityContract } from './activity.contract.js';
import { agentContract } from './agent.contract.js';
import { analyticsContract } from './analytics.contract.js';
import { authContract } from './auth.contract.js';
import { healthContract, healthDetailsContract } from './health.contract.js';
import { healthSourcesContract, overviewContract } from './overview.contract.js';
import { chatContract } from './chat.contract.js';
import { recordsContract } from './records.contract.js';
import { sourceInstancesContract } from './source-instances.contract.js';
import { sourcesContract } from './sources.contract.js';
import { telegramLoginContract } from './telegram-login.contract.js';
import { usersContract } from './users.contract.js';
import { schedulesContract } from './schedules.contract.js';
import { workspacesContract } from './workspaces.contract.js';
const c = initContract();
/**
 * The single source of routes, request schemas and response schemas. The API
 * implements this router and the web client is generated from it, so neither
 * can describe an endpoint the other does not have.
 *
 * Who may call each route is declared on the route itself (`metadata.access`).
 * Every route but the public ones can answer 401, 403 or 500 without saying so
 * route by route.
 */
const guarded = {
    baseHeaders: authHeaders,
    commonResponses: { 401: apiErrorSchema, 403: apiErrorSchema, 500: apiErrorSchema },
};
export const contract = c.router({
    // `check` is public; `sources` carries the guard like everything else.
    health: {
        ...healthContract,
        ...c.router(healthDetailsContract, guarded),
        ...c.router(healthSourcesContract, guarded),
    },
    overview: c.router(overviewContract, guarded),
    auth: c.router(authContract, guarded),
    sources: c.router(sourcesContract, guarded),
    records: c.router(recordsContract, guarded),
    chat: c.router(chatContract, guarded),
    instances: c.router(sourceInstancesContract, guarded),
    telegramLogin: c.router(telegramLoginContract, guarded),
    users: c.router(usersContract, guarded),
    analytics: c.router(analyticsContract, guarded),
    activity: c.router(activityContract, guarded),
    agent: c.router(agentContract, guarded),
    schedules: c.router(schedulesContract, guarded),
    workspaces: c.router(workspacesContract, guarded),
}, { pathPrefix: '/api' });
//# sourceMappingURL=contract.js.map